import { Timestamp } from "firebase/firestore";
function toDate(timestamp) {
    return timestamp?.toDate() ?? null;
}
export function userDTOtoDomain(id, dto) {
    return {
        id,
        name: dto.name,
        email: dto.email,
        phone: dto.phone,
        profileImageUrl: dto.profileImageUrl,
        username: dto.username,
        hasPhone: dto.hasPhone,
        isEmailVerified: dto.isEmailVerified,
        ratingAverage: dto.ratingAverage,
        ratingCount: dto.ratingCount,
        ratingSum: dto.ratingSum,
        deletionRequestedAt: toDate(dto.deletionRequestedAt),
        deletionScheduledAt: toDate(dto.deletionScheduledAt),
    };
}
export function serviceDTOtoDomain(id, dto) {
    return {
        id,
        userId: dto.userId,
        title: dto.title,
        description: dto.description,
        location: dto.location,
        price: dto.price,
        contactInfo: dto.contactInfo,
        imageUrl: dto.imageUrl,
        imageUrls: dto.imageUrls ?? [],
        createdAt: toDate(dto.createdAt),
        commentCount: dto.commentCount,
    };
}
export function serviceDomainToDTO(service) {
    return {
        userId: service.userId,
        title: service.title,
        description: service.description,
        location: service.location,
        price: service.price,
        contactInfo: service.contactInfo,
        imageUrl: service.imageUrl,
        imageUrls: service.imageUrls,
        createdAt: Timestamp.now(),
        commentCount: 0,
    };
}
export function commentDTOtoDomain(id, dto) {
    return {
        id,
        serviceId: dto.serviceId,
        userId: dto.userId,
        userName: dto.userName,
        userUsername: dto.userUsername,
        text: dto.text,
        createdAt: toDate(dto.createdAt),
    };
}
export function favoriteDTOtoDomain(id, dto) {
    return { id, userId: dto.userId, serviceId: dto.serviceId };
}
export function ratingDTOtoDomain(id, dto) {
    return {
        id,
        ratedUserId: dto.ratedUserId,
        raterUserId: dto.raterUserId,
        raterName: dto.raterName,
        raterUsername: dto.raterUsername,
        raterImageUrl: dto.raterImageUrl,
        score: dto.score,
        comment: dto.comment,
        createdAt: toDate(dto.createdAt),
        updatedAt: toDate(dto.updatedAt),
    };
}
export function ratingDomainToDTO(rating) {
    return {
        ratedUserId: rating.ratedUserId,
        raterUserId: rating.raterUserId,
        raterName: rating.raterName,
        raterUsername: rating.raterUsername,
        raterImageUrl: rating.raterImageUrl,
        score: rating.score,
        comment: rating.comment,
        createdAt: Timestamp.now(),
    };
}
export function reportDTOtoDomain(_id, dto) {
    return {
        reporterId: dto.reporterId,
        targetId: dto.targetId,
        targetType: dto.targetType,
        reason: dto.reason,
        createdAt: toDate(dto.createdAt),
        status: dto.status,
    };
}
export function contactMessageDTOtoDomain(_id, dto) {
    return {
        userId: dto.userId,
        userName: dto.userName,
        userEmail: dto.userEmail,
        title: dto.title,
        body: dto.body,
        preferredContact: dto.preferredContact,
        contactValue: dto.contactValue,
        createdAt: toDate(dto.createdAt),
        status: dto.status,
    };
}
//# sourceMappingURL=mappers.js.map